import { useCallback, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import { AllReduxPayloads } from '../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../utils/reducers/company/workingCenters'
import withLoading from '../../../../../utils/hoc/withLoading'
import { LittleModalCreateEditChildrenFirst } from '../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import CustomError from '../../../../../baseComponents/CustomError'
import { FormRender } from '../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { OnSubmit } from '../../../../../forms/TwinForm/types'
import SearchbarQuoteCustomerDeciderComponent from '../../../../../app/erp/screens/Logistic/QuoteParent/QuoteOrders/ModalCreateQuoteOrder/SearchBarQuoteCustomer'
import { getSelectedWorkingCenter } from '../../../../../utils/reducers/getters'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../utils/globals/dictionary'
import { twinFetchPostJSON } from '../../../../../utils/globals/data'
import locations from '../../../../../utils/globals/locations'
import { checkIfCanCreateSell } from '../../../../../utils/globals/order/sell'
import { SellModelTypeExtended } from '../../../../../app/erp/screens/Logistic/QuoteParent/SellParent/headers/types'
import useProjectsAndOpportunitiesDict from '../../../../../utils/hooks/customer/useProjectsAndOpportunitiesDict'

type ModalCreateCustomerSellInvoiceProps = ModalEditComponentProps & ReduxModalCreateCustomerSellInvoiceConnector & {}

const ModalCreateCustomerSellInvoice: React.FC<ModalCreateCustomerSellInvoiceProps> = ({ userPermissions, allRowData, workingCenters, ...rest }) => {
    const { t } = useTwinTranslation()
    const { id, projects, createSellInvoice } = useModalCreateCustomerSellInvoiceLogic()
    const workingCenter = getSelectedWorkingCenter()
    const error = checkIfCanCreateSell(t, workingCenters?.[workingCenter?.id])
    const { parseSearchProjectsToSections } = useProjectsAndOpportunitiesDict()
    const fields: FormRender<SellModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'CustomerProjectId',
                    label: t('project', 'Proyecto'),
                    component: 'CustomSelectSectionsSearchbar',
                    items: projects ? parseSearchProjectsToSections(projects || {}).projectsSectionsByName as any : [],
                    sortItems: true
                },
                {
                    name: 'custom_name',
                    label: t('customName', 'Nombre personalizado'),
                    component: 'InputWithLabelMargin',
                },
                {
                    name: 'OrderId',
                    component: 'Custom',
                    render: () => <SearchbarQuoteCustomerDeciderComponent />
                },
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: workingCenter?.CurrencyId
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                },
                {
                    name: 'CustomerId',
                    component: 'InputHidden',
                    value: id
                }
            ],
        },
    ]
    return (
        <LittleModalCreateEditChildrenFirst fields={error ? [] : fields} url={'/api/app/order/sell/sellInvoice/createSellInvoice'} translations={{
            title: t('newSellInvoice', 'Nuevo pedido'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={!error}  {...{ ...rest, onSubmit: createSellInvoice }} className='gap-27' >
            {error ? <CustomError textError={error} /> : null}
            {!workingCenters?.[workingCenter?.id]?.dictCounters && !error ? <CustomError textError={t('notFoundWorkingCenterCounterAndForceCreate', 'No se han encontrado contadores disponibles. Si decide continuar, se generará uno automáticamente.')} /> : null}
        </LittleModalCreateEditChildrenFirst>)
}


const useModalCreateCustomerSellInvoiceLogic = () => {
    const { id } = useParams()
    const [projects, setProjects] = useState<TwinDictionary | null>(null)
    const navigate = useNavigate()

    const searchItems = useCallback(async () => {
        const searchedItems = await twinFetchPostJSON('/api/app/customer/customerProject/getAllCustomerProjects', {
            where:
            {
                'CustomerProject.active': true,
                CustomerId: id
            },
        })
        if (searchedItems) {
            setProjects(dictionaryComplexFromJsonArr(searchedItems))
        }
    }, [id])
    const createSellInvoice: OnSubmit = useCallback(async (res) => {
        const create = await res.json()
        return navigate(locations.sellInvoiceSingle + '/'+ create.id)
    }, [navigate])

    useEffect(() => {
        searchItems()
    }, [searchItems])

    return { projects, createSellInvoice, id}
}


const modalCreateCustomerSellInvoiceDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
}
const mapModalCreateCustomerSellInvoiceConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters})
const modalCreateCustomerSellInvoiceConnector = connect(mapModalCreateCustomerSellInvoiceConnector, modalCreateCustomerSellInvoiceDispatch)
type ReduxModalCreateCustomerSellInvoiceConnector = ConnectedProps<typeof modalCreateCustomerSellInvoiceConnector>
const modalCreateCustomerSellInvoiceConnectLoading = withLoading(ModalCreateCustomerSellInvoice, [{ fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const ModalCreateCustomerSellInvoiceConnect = modalCreateCustomerSellInvoiceConnector(modalCreateCustomerSellInvoiceConnectLoading)

export default ModalCreateCustomerSellInvoiceConnect